export class ValidationMessage {
    constructor(public message: string, public controlName: string, public formName: string, public formLink: string, public index: number){}
}